import { Brush, Frown, type LucideIcon, ShieldAlert, TestTube, TrendingUp, TriangleAlert } from 'lucide-react';

import type { AlertLabelKey, AlertSeverity } from './AlertChip.types';

/**
 * Closed catalogue of triage alerts, mirroring `_ALERTS_SQL`
 * (`sql_conversations_repo.py:904`). The backend derives these on read from
 * what it already stores; there are exactly six.
 *
 * An unknown value is NOT dropped — it renders neutral with its raw string, so
 * the day `back#SPEC-007` appends `reported` the UI shows it without a release.
 */
export const ALERT_STYLES: Record<string, { icon: LucideIcon; severity: AlertSeverity; labelKey: AlertLabelKey }> = {
	graph_error: { icon: TriangleAlert, severity: 'error', labelKey: 'ALERT_GRAPH_ERROR' },
	judge_failed: { icon: TestTube, severity: 'error', labelKey: 'ALERT_JUDGE_FAILED' },
	prompt_injection: { icon: ShieldAlert, severity: 'error', labelKey: 'ALERT_PROMPT_INJECTION' },
	llm_escalation: { icon: TrendingUp, severity: 'warning', labelKey: 'ALERT_LLM_ESCALATION' },
	frustration: { icon: Frown, severity: 'warning', labelKey: 'ALERT_FRUSTRATION' },
	p9_scrub: { icon: Brush, severity: 'info', labelKey: 'ALERT_P9_SCRUB' },
};

export const SEVERITY_CLASS: Record<AlertSeverity, string> = {
	error: 'border-red-200 bg-red-50 text-error',
	warning: 'border-yellow-200 bg-yellow-50 text-warning',
	info: 'border-blue-200 bg-blue-50 text-info',
	neutral: 'border-subtle bg-grey-25 text-subtle',
};
